import { render } from "./AppModal.vue?vue&type=template&id=5571081f&scoped=true"
import script from "./AppModal.vue?vue&type=script&lang=js"
export * from "./AppModal.vue?vue&type=script&lang=js"

import "./AppModal.vue?vue&type=style&index=0&id=5571081f&lang=scss&scoped=true"
import "./AppModal.vue?vue&type=style&index=1&id=5571081f&lang=scss"

import exportComponent from "/Users/carolinehansen/Sites/work-manyone/koebenhavns-kommune/bygdrift/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5571081f"]])

export default __exports__